import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { HStack } from "@whoosh/design-system/src/components/primitive";

import { getBookingGroupSizeAtom } from "../../../../../../../../../atoms/selectors/getBookingGroupSizeAtom/getBookingGroupSizeAtom";
import { getRateFromRoundIdAtom } from "../../../../../../../../../atoms/selectors/getRateFromRoundIdAtom/getRatefromRoundIdAtom";
import { DurationPlayerRateControl } from "./DurationPlayerRateControl/DurationPlayerRateControl";
import { DurationRoundControls_Booking$key } from "./__generated__/DurationRoundControls_Booking.graphql";

type Props = {
  bookingRef: DurationRoundControls_Booking$key;
  roundId: string;
  currentMembershipTypeId: string;
};

export const DurationRoundControls = ({
  bookingRef,
  roundId,
  currentMembershipTypeId,
}: Props) => {
  const getRoundRate = useAtomValue(getRateFromRoundIdAtom(roundId));
  const booking = useFragment(DurationRoundControlsFragmentString, bookingRef);
  const groupSize = useAtomValue(getBookingGroupSizeAtom);

  if (!getRoundRate) {
    return null;
  }

  return (
    <HStack gap={1}>
      <DurationPlayerRateControl
        bookingId={booking?.id || ""}
        currentMembershipTypeId={currentMembershipTypeId}
        durationMins={booking?.durationMins ?? 15}
        groupSize={groupSize ?? 1}
        roundId={roundId}
      />
    </HStack>
  );
};
const DurationRoundControlsFragmentString = graphql`
  fragment DurationRoundControls_Booking on Booking {
    id
    ... on StandardBooking {
      durationMins
    }
    rounds {
      count
    }
  }
`;
